import React, { useEffect, useState } from "react";
import { Row, Col, Image, Button } from "react-bootstrap";
import InviteModalNext from "./invite-modal-next";
import FullWidthImage from "components/full-width-image";
import { usePhonePortraitContext } from "contexts/phone-portrait-context";
import { useUser } from "contexts/UserContext";
import getClasses from "utils/getClasses";
import styles from "./styles.module.scss";
import { AmplitudePageName, track } from "utils/amplitude";
import { useTimeOnPageContext } from "contexts/time-on-page";

const INVITE_OTHERS = "/img/dashboard/invite-landing-web.png";
const INVITE_PERSON = "/img/dashboard/invite-person.png";

const AMPLITUDE_PAGE_NAME: AmplitudePageName = "pro-invite-to-orchid-page";

const InviteOthers = () => {
  const { setPage } = useTimeOnPageContext();
  useEffect(() => setPage(AMPLITUDE_PAGE_NAME), [setPage]);

  const { isPhonePortrait } = usePhonePortraitContext();
  const { user } = useUser();

  const [invitee, setInvitee] = useState("");
  const [showInviteModalNext, setShowInviteModalNext] = useState(false);

  return (
    <div
      className={
        !isPhonePortrait
          ? styles["invite-others-container"]
          : styles["invite-others-container--phone"]
      }
    >
      <div className="text-center">
        {!isPhonePortrait ? (
          <Row className="p-3 mb-3">
            <FullWidthImage src={INVITE_OTHERS} fluid />
          </Row>
        ) : (
          <Image
            className={styles["invite-others__landing-img"]}
            src={INVITE_PERSON}
            fluid
          />
        )}
        <h2
          className={getClasses(
            !isPhonePortrait ? "rg-32 questrial" : "rg-24 deep-blue questrial",
          )}
        >
          Help grow the Orchid community
        </h2>
        {user?.user_type === "member" ? (
          <>
            <p className="rg-14 mb-1">
              Get $10 off your next session whenever one of your referrals
              joins!
            </p>
          </>
        ) : null}
        <Row className={styles["invite-options-container"]}>
          {/* <Col
            md={6}
            xs={12}
            className={getClasses(
              isPhonePortrait && styles["invite-option--phone"],
              styles["invite-option"],
            )}
          >
            {user?.user_type === "orchid_pro" ? (
              <div>
                <p className="bd-16 deep-blue mb-2">
                  Invite clients or patients
                </p>
                <p
                  className={getClasses(
                    "mb-1",
                    styles["invite-option__content"],
                  )}
                >
                  Treating someone who should join Orchid?
                </p>
                <p className={styles["invite-option__content"]}>
                  Tell them how to join and easily book you.
                </p>
              </div>
            ) : (
              <div>
                <p className="bd-16 deep-blue mb-2">
                  Invite clients or patients
                </p>
                <p
                  className={getClasses(
                    "mb-1",
                    styles["invite-option__content"],
                  )}
                >
                  Know someone who needs mental healthcare?
                </p>
                <p className={styles["invite-option__content"]}>
                  Tell them why Orchid could help.
                </p>
              </div>
            )}
            <Button
              className={
                !isPhonePortrait
                  ? styles["invite-option__button"]
                  : styles["invite-option__button--phone"]
              }
              onClick={() => {
                setInvitee("member");
                setShowInviteModalNext(true);
              }}
            >
              Send invite
            </Button>
          </Col> */}
          <Col
            md={12}
            xs={12}
            className={getClasses(
              isPhonePortrait && styles["invite-option--phone"],
              styles["invite-option"],
            )}
          >
            {user?.user_type === "orchid_pro" ? (
              <div>
                <p className="bd-16 deep-blue mb-2">Refer a colleague</p>
                <p
                  className={getClasses(
                    "mb-1",
                    styles["invite-option__content"],
                  )}
                >
                  Know a colleague who's ready for a change?
                </p>
                <p className={styles["invite-option__content"]}>
                  Invite them to use the best EHR platform.
                </p>
              </div>
            ) : (
              <div>
                <p className="bd-16 deep-blue mb-2">
                  Refer healthcare professionals
                </p>
                <p
                  className={getClasses(
                    "mb-1",
                    styles["invite-option__content"],
                  )}
                >
                  Know a professional who could join Orchid?
                </p>
                <p className={styles["invite-option__content"]}>
                  Help make mental healthcare more accessible.
                </p>
              </div>
            )}
            <Button
              className={
                !isPhonePortrait
                  ? styles["invite-option__button"]
                  : styles["invite-option__button--phone"]
              }
              onClick={() => {
                setInvitee("orchid_pro");
                setShowInviteModalNext(true);
                track(AMPLITUDE_PAGE_NAME, "send-referral-button", "click");
              }}
            >
              Send referral
            </Button>
          </Col>
        </Row>
        <InviteModalNext
          show={showInviteModalNext}
          onHide={() => setShowInviteModalNext(false)}
          invitee={invitee}
        />
      </div>
    </div>
  );
};

export default InviteOthers;
